import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Button, Tooltip } from '@getro/rombo';
import { ExternalLink } from 'lucide-react';
import copy from 'copy-to-clipboard';

const SharedListLink = ({ listUrl, ...props }) => {
  const timer = useRef(null);
  const [urlTooltipOpen, setUrlTooltipOpen] = useState(false);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copyURLToClipboard = (urlToCopy) => {
    copy(urlToCopy);
    setUrlTooltipOpen(true);

    timer.current = setTimeout(() => {
      setUrlTooltipOpen(false);
    }, 2000);
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      flexDirection="row"
      py="2"
      px="3"
      bg="neutral.0"
      sx={{
        borderRadius: '4px',
        border: '1px solid',
        borderColor: 'neutral.400',
        gap: '16px',
      }}
      {...props}
    >
      <Text
        color="text.main"
        as="div"
        sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '14px', overflow: 'hidden' }}
      >
        {listUrl}
      </Text>
      <Flex alignItems="center" sx={{ gap: '8px' }}>
        <Box sx={{ cursor: 'pointer', lineHeight: '16px' }}>
          <Tooltip
            content="Open in a new tab"
            trigger={
              <Box
                as={ExternalLink}
                width="16px"
                height="16px"
                tabIndex={0}
                role="button"
                aria-label="Open list in a new tab"
                onClick={() => window.open(listUrl, '_blank', 'noopener,noreferrer')}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    window.open(listUrl, '_blank', 'noopener,noreferrer');
                  }
                }}
              />
            }
          />
        </Box>
        <Box sx={{ cursor: 'pointer', lineHeight: '16px' }}>
          {!urlTooltipOpen ? (
            <Tooltip
              content="Copy list link"
              trigger={
                <Button
                  variant="accent"
                  size="small"
                  onClick={() => copyURLToClipboard(listUrl)}
                  sx={{ width: '97px' }}
                >
                  Copy link
                </Button>
              }
            />
          ) : (
            <Tooltip
              content="Link Copied"
              delayHide={1000}
              isOpen
              trigger={
                <Button variant="accent" size="small" onClick={() => {}} sx={{ width: '97px' }}>
                  Copy link
                </Button>
              }
            />
          )}
        </Box>
      </Flex>
    </Flex>
  );
};

SharedListLink.propTypes = {
  listUrl: PropTypes.string.isRequired,
};

export default SharedListLink;
